import { useEffect, useState } from 'react'
import type { Shelf } from '../types/music'
import { shelfSeeds } from '../data/seeds'
import { searchTracks } from '../utils/itunes'

interface ShelvesState {
  shelves: Shelf[]
  isLoading: boolean
  error: string | null
}

/** Runs the seed genre/artist searches in parallel to populate the home rows. */
export function useShelves(): ShelvesState {
  const [state, setState] = useState<ShelvesState>({ shelves: [], isLoading: true, error: null })

  useEffect(() => {
    const controller = new AbortController()
    let cancelled = false

    Promise.all(
      shelfSeeds.map(async (seed) => {
        try {
          const tracks = await searchTracks(seed.term, 18, controller.signal)
          return { ...seed, tracks }
        } catch {
          return { ...seed, tracks: [] }
        }
      }),
    ).then((results) => {
      if (cancelled) return
      const populated = results.filter((shelf) => shelf.tracks.length > 0)
      setState({
        shelves: populated,
        isLoading: false,
        error: populated.length ? null : 'Could not reach the iTunes catalogue. Check your connection and retry.',
      })
    })

    return () => {
      cancelled = true
      controller.abort()
    }
  }, [])

  return state
}
